var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#322D29;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-673 -42)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(673 42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2,17.6H19V14.2H2Zm1.7-2.55H5.4v1.7H3.7ZM2,4V7.4H19V4ZM5.4,6.55H3.7V4.85H5.4ZM2,12.5H19V9.1H2ZM3.7,9.95H5.4v1.7H3.7Z",
    transform: "translate(671.5 40)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLog);
export default __webpack_public_path__ + "static/media/icon_log.271f80fd5cd04d4c722fa03ea81f44e7.svg";
export { ForwardRef as ReactComponent };